import BaseService from '@/services/BaseService';

class CrossReferenceService extends BaseService {
    getProductCrossReferenceList = (data) => this.post(
        `/get-product-cross-reference-list?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    changeCrossReferenceStatus = (data) => this.post(
        '/update-product-cross-reference-status',
        data,
    );

    createCrossReference = (data) => this.post(
        '/create-product-cross-reference',
        data,
    );

    viewCrossReference = (id) => this.get(
        `/view-product-cross-reference/${id}`,
    );

    editCrossReference = (id, data) => this.post(
        `/edit-product-cross-reference/${id}`,
        data,
    );

    getProductCrossReferenceListOptions = (data) => this.post(
        '/get-product-list-options',
        { search: data.search } || {},
    );

    exportCrossReference = () => this.get(
        '/export-cross-reference',
    );
}

export default new CrossReferenceService();
